import { defineMessages, useIntl } from 'react-intl';
import { Listing } from '@designsystem/stories/04-organisms/Listing';
import { testimonialToCard } from './adapters/cards';
import { PloneImage } from '@fhnw/types/image';

export const messages = defineMessages({
  prevPage: {
    id: 'Previous page',
    defaultMessage: 'Previous page',
  },
  nextPage: {
    id: 'Next page',
    defaultMessage: 'Next page',
  },
  swipeToNavigate: {
    id: 'Swipe to navigate',
    defaultMessage: 'Swipe to navigate',
  },
});

export interface Testimonial {
  name?: string;
  description?: string;
  title?: string;
  image?: PloneImage;
  focus_point: string;
}

export interface TestimonialData {
  prominent?: boolean;
  testimonials?: Testimonial[];
}

interface TestimonialProps {
  data?: TestimonialData;
  isEditMode?: boolean;
}

const TestimonialsView = ({ data = {} }: TestimonialProps) => {
  const intl = useIntl();

  if (!data?.testimonials) {
    return null;
  }

  return (
    <Listing
      type="testimonial"
      slider={true}
      prevLabel={intl.formatMessage(messages.prevPage)}
      nextLabel={intl.formatMessage(messages.nextPage)}
      swipeLabel={intl.formatMessage(messages.swipeToNavigate)}
      items={data.testimonials.map((item) =>
        testimonialToCard(item, data?.prominent),
      )}
    />
  );
};

export default TestimonialsView;
